<template>
  <md-table v-model="plants" class="table-striped" table-header-color="primary">
    <md-table-row slot="md-table-row" slot-scope="{ item }">
      <md-table-cell md-label="Serial No.">
        {{ item.serialNo }}
      </md-table-cell>
      <md-table-cell md-label="Location">
        {{ item.location }}
      </md-table-cell>
      <md-table-cell class="text-right">
        <md-button class="md-just-icon md-primary" @click="viewItem(item.id)">
          <md-tooltip>View Plant</md-tooltip>
          <md-icon>forward</md-icon>
        </md-button>
      </md-table-cell>
    </md-table-row>
    <md-table-empty-state md-label="No Plant Found"></md-table-empty-state>
  </md-table>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      plants: "portfolio/plants"
    })
  },
  methods: {
    viewItem(id) {
      this.$router.push({
        name: "Plant Details",
        params: { plantId: id }
      });
    }
  }
};
</script>

<style></style>
